// src/component/Login/Login.js
import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Typography,
  Card,
  message,
  Layout,
} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import "../Login/Login.css";
import senalogo from "../../assets/logo.png";

const { Header } = Layout;
const { Title } = Typography;

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login, logout, checkAuth } = useAuth();
  const navigate = useNavigate();
  const handleLogin = async () => {
    try {
      const userData = { username, password };
      const response = await fetch("/api/portal/pms/login", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });
      const data = await response.json();
      if (response.ok && data.serviceResult) {
        console.log(data);
        login(data.serviceResult);

        const isSessionValid = await checkAuth({ skipLogoutOnFail: true });

        if (!isSessionValid) {
          logout();
          message.error("Login succeeded but session validation failed.");
          return;
        }

        if (data.serviceResult.role === "PCS") {
          navigate("/dashboard/AssigneSearch");
        } else if (
          data.serviceResult.role === "PAS" ||
          data.serviceResult.role === "PAT"
        ) {
          navigate("/dashboard/PetitionManagement");
        } else {
          navigate("/dashboard/PetitionManagement");
        }
      } else {
        message.error(data.serviceError);
      }
    } catch (error) {
      console.error("Login Error:", error);
      message.error("Login failed. Please try again.");
    }
  };

  const cardStyle = {
    width: "70%",
    maxWidth: "400px",
    padding: "24px",
    margin: "0 auto",
    marginTop: "0px",
    boxShadow: "0 1px 3px #ebd7d7",
    textAlign: "center",
  };

  const buttonStyle = {
    width: "100%",
    background: "linear-gradient(to right, #df1217, #900b0a)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#d92027 !important",
    height: "64px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  };
  const titleStyle = {
    color: "#fff",
    marginLeft: "16px",
    fontSize: "30px",
    fontWeight: "600",
  };

  const logoStyle = {
    width: 80,
    height: 80,
    marginBottom: "20px",
    marginTop: "-30px",
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#d92027",
          display: "flex",
          alignItems: "center",
          height: "64px",
          padding: "0 70px",
          boxShadow: "rgb(96, 125, 139) 0px 3px 5px",
        }}
      >
        <img
          src={senalogo}
          alt="Logo"
          style={{ width: 50, height: 50 }} // Adjusted size for better alignment
        />
        <div style={titleStyle}>Janasena</div>
      </div>

      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh", backgroundColor: "#f5f5f5" }}
      >
        <Col xs={20} sm={16} md={12} lg={8}>
          <Card style={cardStyle}>
            {/* Logo at the top of the card */}
            <img src={senalogo} alt="Logo" style={logoStyle} />
            <div style={{ marginBottom: "20px" }}>
              <Title level={2}>Login</Title>
            </div>
            <Form onFinish={handleLogin}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please enter your username" },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  prefix={<UserOutlined />}
                  style={{ width: "100%" }}
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  style={{ width: "100%" }}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" style={buttonStyle}>
                  Login
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default LoginPage;
